import { render, staticRenderFns } from "./CurrencyRates.vue?vue&type=template&id=c16d8abe&"
import script from "./CurrencyRates.vue?vue&type=script&lang=js&"
export * from "./CurrencyRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports